/*
 * JAPON!SM — Stockists / お取り扱い店
 *
 * 前提: 店舗一覧は Liquid が既に描画済み。このスクリプトは
 *       「地図」「現在地から探す」「エリア・カテゴリ絞り込み」を上乗せするだけ。
 *       読み込みに失敗しても一覧はそのまま読める。
 *
 * 地図: Leaflet（テーマ同梱 assets/leaflet.js）。タイルURL・出典・最大ズームは
 *       地図要素の data 属性から受け取る（配信元の切り替えは Liquid 側の責務）。
 *
 * プライバシー: 現在地は距離計算とマップ表示のためにブラウザ内でのみ使用し、
 *               外部へ送信・保存しない。
 */
(function () {
  'use strict';

  var EARTH_KM = 6371;

  // 日本のおおよその外接矩形。国土地理院タイルは国外が白紙になるため、
  // 現在地が範囲外のときは地図を動かさず一覧の並べ替えだけ行う。
  var JP_BOUNDS = { south: 20.0, north: 46.5, west: 122.0, east: 154.0 };

  function haversine(lat1, lng1, lat2, lng2) {
    var rad = Math.PI / 180;
    var dLat = (lat2 - lat1) * rad;
    var dLng = (lng2 - lng1) * rad;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return EARTH_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function parseJSONFrom(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /*
   * metaobject の number_decimal は Liquid 経由で文字列になることがある（"35.76…"）。
   * 型で判定すると全件が「座標なし」になってピンが1つも出ないので、必ず数値化してから見る。
   */
  function toNumber(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    return isFinite(n) ? n : NaN;
  }

  function hasCoords(d) {
    return isFinite(d.lat) && isFinite(d.lng) && (d.lat !== 0 || d.lng !== 0);
  }

  function escapeHTML(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function inJapan(p) {
    return (
      p.lat >= JP_BOUNDS.south && p.lat <= JP_BOUNDS.north && p.lng >= JP_BOUNDS.west && p.lng <= JP_BOUNDS.east
    );
  }

  var instances = [];

  function Stockists(root) {
    this.root = root;
    this.list = root.querySelector('[data-stockists-list]');
    this.statusEl = root.querySelector('[data-stockists-status]');
    this.mapEl = root.querySelector('[data-stockists-map]');
    this.mapFailEl = root.querySelector('[data-stockists-mapfail]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-stockists-item]'));
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-stockists-group]'));
    // 見出しを含む元の並び。距離順から戻すときに使う
    this.nodes = this.list ? Array.prototype.slice.call(this.list.children) : [];
    // 座標は受け取った直後に数値へ揃える（以降は数値であることを前提にしてよい）
    this.data = (parseJSONFrom(root.querySelector('[data-stockists-data]')) || []).map(function (d, n) {
      return {
        i: typeof d.i === 'number' ? d.i : n,
        name: d.name,
        pref: d.pref,
        lat: toNumber(d.lat),
        lng: toNumber(d.lng)
      };
    });
    this.strings = parseJSONFrom(root.querySelector('[data-stockists-strings]')) || {};
    this.markers = [];
    this.origin = null;
    this.originMarker = null;
    this.map = null;

    if (!this.list || !this.items.length) return;

    // 操作パネルは JS が動いた時だけ見せる（JS無効なら最初から非表示のまま）
    var controls = root.querySelector('[data-stockists-controls]');
    if (controls) controls.hidden = false;

    this.bind();
  }

  Stockists.prototype.t = function (key, token, value) {
    var s = this.strings[key] || '';
    if (token) s = s.split(token).join(value);
    return s;
  };

  Stockists.prototype.say = function (message) {
    if (this.statusEl) this.statusEl.textContent = message;
  };

  Stockists.prototype.bind = function () {
    var self = this;

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-stockists-filter]'), function (sel) {
      sel.addEventListener('change', function () {
        self.applyFilter();
      });
    });

    this.resetBtn = this.root.querySelector('[data-stockists-reset]');
    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', function () {
        Array.prototype.forEach.call(self.root.querySelectorAll('[data-stockists-filter]'), function (sel) {
          sel.value = '';
        });
        self.origin = null;
        self.clearDistances();
        self.restoreOrder();
        self.applyFilter();
        self.say('');
      });
    }

    var geo = this.root.querySelector('[data-stockists-geo]');
    if (geo) {
      geo.addEventListener('click', function () {
        self.locate(geo);
      });
    }
  };

  /* ---------- 現在地 ---------- */

  Stockists.prototype.locate = function (btn) {
    var self = this;

    if (!navigator.geolocation) {
      this.say(this.t('geo_unsupported'));
      return;
    }

    btn.setAttribute('aria-busy', 'true');
    this.say(this.t('geo_searching'));

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        btn.removeAttribute('aria-busy');
        self.origin = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        self.sortByDistance();
        self.say(self.t('geo_done'));
        self.updateResetVisibility();
      },
      function () {
        btn.removeAttribute('aria-busy');
        // 拒否・失敗しても一覧と絞り込みはそのまま使える
        self.say(self.t('geo_denied'));
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
  };

  Stockists.prototype.sortByDistance = function () {
    var self = this;
    var origin = this.origin;
    if (!origin) return;

    this.data
      .filter(hasCoords)
      .map(function (d) {
        return { i: d.i, km: haversine(origin.lat, origin.lng, d.lat, d.lng) };
      })
      .sort(function (a, b) {
        return a.km - b.km;
      })
      .forEach(function (entry) {
        var li = self.items[entry.i];
        if (!li) return;
        var out = li.querySelector('[data-stockists-distance]');
        if (out) {
          out.textContent = self.t('distance', '{km}', entry.km.toFixed(1));
          out.hidden = false;
        }
        self.list.appendChild(li);
      });

    // 座標未登録の店舗は末尾へ
    this.data
      .filter(function (d) {
        return !hasCoords(d);
      })
      .forEach(function (d) {
        if (self.items[d.i]) self.list.appendChild(self.items[d.i]);
      });

    // 距離順では県ごとの並びが崩れるので、見出しは畳む
    this.updateGroups(true);

    // 国外からの利用では地図を動かさない（国土地理院タイルは日本国内のみで白紙になるため）
    if (this.map && inJapan(origin)) {
      this.showOrigin(origin);
      this.map.setView([origin.lat, origin.lng], 11);
    }
  };

  Stockists.prototype.clearDistances = function () {
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-stockists-distance]'), function (el) {
      el.hidden = true;
      el.textContent = '';
    });
  };

  Stockists.prototype.restoreOrder = function () {
    var self = this;
    // 見出しごと元の順序に戻す
    this.nodes.forEach(function (node) {
      self.list.appendChild(node);
    });
    if (this.originMarker && this.map) {
      this.map.removeLayer(this.originMarker);
      this.originMarker = null;
    }
    this.fitAll();
  };

  /* ---------- 絞り込み ---------- */

  Stockists.prototype.applyFilter = function () {
    var self = this;
    var areaSel = this.root.querySelector('[data-stockists-filter="area"]');
    var catSel = this.root.querySelector('[data-stockists-filter="category"]');
    var area = areaSel ? areaSel.value : '';
    var cat = catSel ? catSel.value : '';
    var shown = 0;

    this.items.forEach(function (li, i) {
      var ok =
        (!area || li.getAttribute('data-area') === area) && (!cat || li.getAttribute('data-category') === cat);
      li.hidden = !ok;
      self.setMarkerVisible(i, ok);
      if (ok) shown++;
    });

    // 距離順のあいだは見出しを出さない
    this.updateGroups(!!this.origin);
    this.syncPrefLabels();

    this.say(shown === 0 ? this.t('no_results') : this.t('results', '{count}', shown));
    this.updateResetVisibility();
    this.fitAll();
  };

  /* 見出しは、その県に表示中の店舗が1つ以上あるときだけ出す */
  Stockists.prototype.updateGroups = function (collapsed) {
    this.groups.forEach(function (heading) {
      if (collapsed) {
        heading.hidden = true;
        return;
      }
      var hasVisible = false;
      var node = heading.nextElementSibling;
      while (node && !node.hasAttribute('data-stockists-group')) {
        if (!node.hidden) {
          hasVisible = true;
          break;
        }
        node = node.nextElementSibling;
      }
      heading.hidden = !hasVisible;
    });
  };

  Stockists.prototype.updateResetVisibility = function () {
    if (!this.resetBtn) return;
    var areaSel = this.root.querySelector('[data-stockists-filter="area"]');
    var catSel = this.root.querySelector('[data-stockists-filter="category"]');
    var dirty = (areaSel && areaSel.value) || (catSel && catSel.value) || this.origin;
    this.resetBtn.hidden = !dirty;
  };

  /* ---------- 選択 ---------- */

  /* ピンが選ばれた時の見た目を合わせる。地図は動かさない（押した場所から視線を移さない） */
  Stockists.prototype.select = function (index) {
    var self = this;

    this.items.forEach(function (li, i) {
      li.classList.toggle('is-active', i === index);
    });

    this.markers.forEach(function (marker, i) {
      self.paintMarker(marker, i === index);
    });
  };

  /* ---------- 地図 ---------- */

  /*
   * ポップアップの中身は一覧のカードを複製して作る。
   * 文言も日英切替も Liquid 側に一本化でき、表示のずれが起きない。
   */
  Stockists.prototype.popupContent = function (index) {
    var li = this.items[index];
    var card = li && li.querySelector('.stockists__card');
    if (!card) return null;

    var node = card.cloneNode(true);
    // 現在地からの距離は一覧側の情報なので、ポップアップには出さない
    Array.prototype.forEach.call(node.querySelectorAll('[data-stockists-distance]'), function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    return node;
  };

  /*
   * 取扱店のある都道府県名だけを地図に重ねる。
   * 地図タイル側の地名に頼らないので、表示言語（日本語／英語）にそのまま追従する。
   *
   * 置き場所は毎回その場で決める：県の店舗群の重心を起点に、上・下・左・右…と候補をずらし、
   * ピンにも他のラベルにも当たらない最初の位置を採る。どこにも置けなければその県は出さない
   * （引きの状態で関東4県を全部並べるのは物理的に無理なため、ズームすると順に現れる）。
   */
  Stockists.prototype.buildPrefLabels = function () {
    var groups = {};

    this.data.forEach(function (d) {
      if (!hasCoords(d) || !d.pref) return;
      if (!groups[d.pref]) groups[d.pref] = [];
      groups[d.pref].push(d);
    });

    this.prefLabels = Object.keys(groups).map(function (name) {
      var members = groups[name];
      var sum = members.reduce(
        function (acc, d) {
          return { lat: acc.lat + d.lat, lng: acc.lng + d.lng };
        },
        { lat: 0, lng: 0 }
      );

      return {
        name: name,
        members: members,
        anchor: [sum.lat / members.length, sum.lng / members.length],
        marker: window.L.marker([sum.lat / members.length, sum.lng / members.length], {
          icon: window.L.divIcon({
            className: 'stockists-preflabel',
            html: '<span>' + escapeHTML(name) + '</span>',
            iconSize: [150, 18],
            // 中央を基準に置く（配置はスクリーン座標で決めるため）
            iconAnchor: [75, 9]
          }),
          interactive: false,
          keyboard: false,
          // ピンより奥へ
          zIndexOffset: -1000
        })
      };
    });

    // 店舗の多い県ほど先に場所を取る（東京が落ちないように）
    this.prefLabels.sort(function (a, b) {
      return b.members.length - a.members.length;
    });
  };

  Stockists.prototype.syncPrefLabels = function () {
    if (!this.map || !this.prefLabels) return;

    var self = this;
    var LABEL_W = 34; // ラベル半幅の目安（px）
    var LABEL_H = 10; // ラベル半高の目安（px）
    var OFFSETS = [
      [0, -28],
      [0, 28],
      [-70, 0],
      [70, 0],
      [0, -50],
      [0, 50]
    ];

    // 表示中のピンの位置。ラベルはここを避ける
    var pins = [];
    this.data.forEach(function (d, i) {
      if (!hasCoords(d)) return;
      var li = self.items[i];
      if (li && li.hidden) return;
      pins.push(self.map.latLngToContainerPoint([d.lat, d.lng]));
    });

    var placed = [];

    this.prefLabels.forEach(function (entry) {
      var hasVisibleShop = entry.members.some(function (d) {
        var li = self.items[d.i];
        return !li || !li.hidden;
      });

      var spot = null;

      if (hasVisibleShop && !self.detailActive) {
        var base = self.map.latLngToContainerPoint(entry.anchor);

        for (var k = 0; k < OFFSETS.length && !spot; k++) {
          var pt = { x: base.x + OFFSETS[k][0], y: base.y + OFFSETS[k][1] };

          var hitsLabel = placed.some(function (other) {
            return Math.abs(other.x - pt.x) < LABEL_W * 2 && Math.abs(other.y - pt.y) < LABEL_H * 2.4;
          });
          var hitsPin = pins.some(function (pin) {
            return Math.abs(pin.x - pt.x) < LABEL_W + 10 && Math.abs(pin.y - pt.y) < LABEL_H + 10;
          });

          if (!hitsLabel && !hitsPin) spot = pt;
        }
      }

      if (spot) {
        placed.push(spot);
        entry.marker.setLatLng(self.map.containerPointToLatLng(spot));
        if (!self.map.hasLayer(entry.marker)) entry.marker.addTo(self.map);
      } else if (self.map.hasLayer(entry.marker)) {
        self.map.removeLayer(entry.marker);
      }
    });
  };

  Stockists.prototype.pinIcon = function (modifier) {
    return window.L.divIcon({
      className: 'stockists-pin' + (modifier ? ' ' + modifier : ''),
      html: '',
      iconSize: [16, 16],
      iconAnchor: [8, 8]
    });
  };

  Stockists.prototype.paintMarker = function (marker, isActive) {
    if (!marker) return;
    var el = marker.getElement();
    if (el) el.classList.toggle('is-active', isActive);
    marker.setZIndexOffset(isActive ? 1000 : 0);
  };

  Stockists.prototype.setMarkerVisible = function (i, visible) {
    var marker = this.markers[i];
    if (!marker || !this.map) return;
    if (visible && !this.map.hasLayer(marker)) marker.addTo(this.map);
    else if (!visible && this.map.hasLayer(marker)) this.map.removeLayer(marker);
  };

  Stockists.prototype.showOrigin = function (origin) {
    if (!this.map) return;
    if (this.originMarker) this.map.removeLayer(this.originMarker);

    this.originMarker = window.L.marker([origin.lat, origin.lng], {
      icon: this.pinIcon('stockists-pin--origin'),
      title: this.t('you_are_here'),
      alt: this.t('you_are_here'),
      keyboard: false,
      interactive: false
    }).addTo(this.map);
  };

  Stockists.prototype.fitAll = function () {
    if (!this.map) return;

    var points = [];
    var self = this;

    this.data.forEach(function (d, i) {
      if (!hasCoords(d)) return;
      if (self.items[i] && self.items[i].hidden) return;
      points.push([d.lat, d.lng]);
    });

    if (this.origin && inJapan(this.origin)) points.push([this.origin.lat, this.origin.lng]);
    if (!points.length) return;

    this.map.fitBounds(window.L.latLngBounds(points), { padding: [40, 40], maxZoom: 15 });
  };

  Stockists.prototype.initMap = function () {
    var self = this;
    if (!this.mapEl || this.map || !this.items.length) return;

    if (!window.L || !window.L.map) {
      // Leaflet が読めなかった。一覧は既に読めているので地図だけ諦める
      if (this.mapFailEl) this.mapFailEl.hidden = false;
      return;
    }

    if (!this.data.some(hasCoords)) return;

    var wrap = this.root.querySelector('[data-stockists-mapwrap]');
    if (wrap) wrap.hidden = false;

    function makeLayer(t) {
      return window.L.tileLayer(t.url, { attribution: t.attr || '', maxZoom: t.max || 18 });
    }

    var cfg = parseJSONFrom(this.root.querySelector('[data-stockists-map-config]')) || {};
    var lowLayers = (cfg.low || []).map(makeLayer);
    var highLayers = (cfg.high || []).map(makeLayer);
    var switchAt = cfg.switch || 0;

    if (!lowLayers.length) {
      if (this.mapFailEl) this.mapFailEl.hidden = false;
      return;
    }

    var options = {
      center: [36.2048, 138.2529],
      zoom: 5,
      // ページを読む邪魔をしないよう、ホイールでのズームは無効（±ボタン・ピンチは有効）
      scrollWheelZoom: false
    };
    if (cfg.minZoom) options.minZoom = cfg.minZoom;
    this.map = window.L.map(this.mapEl, options);

    // 引き=落ち着いた地図／寄せ=地名入りの地図に自動で入れ替える（high が空なら常に low）
    this.syncBaseLayer = function () {
      var useHigh = highLayers.length > 0 && switchAt > 0 && self.map.getZoom() >= switchAt;
      self.detailActive = useHigh;
      var on = useHigh ? highLayers : lowLayers;
      var off = useHigh ? lowLayers : highLayers;
      off.forEach(function (layer) {
        if (self.map.hasLayer(layer)) self.map.removeLayer(layer);
      });
      // 配列の順に重ねる（先頭が下、ラベル層は後ろ）
      on.forEach(function (layer) {
        if (!self.map.hasLayer(layer)) layer.addTo(self.map);
      });
    };

    this.syncBaseLayer();
    if (highLayers.length) this.map.on('zoomend', this.syncBaseLayer);

    if (cfg.prefLabels) {
      this.buildPrefLabels();
      this.map.on('zoomend moveend', function () {
        self.syncBaseLayer();
        self.syncPrefLabels();
      });
    }

    this.data.forEach(function (d, i) {
      if (!hasCoords(d)) {
        self.markers[i] = null;
        return;
      }

      var marker = window.L.marker([d.lat, d.lng], {
        icon: self.pinIcon(),
        title: d.name,
        alt: d.name,
        riseOnHover: true
      });

      // divIcon は img ではないので alt が付かない。読み上げ用に補う
      marker.on('add', function () {
        var el = marker.getElement();
        if (el) {
          el.setAttribute('role', 'button');
          el.setAttribute('aria-label', d.name);
        }
      });

      // ピンを押したら、その場に店舗情報を出す（一覧へスクロールはしない）
      var content = self.popupContent(i);
      if (content) {
        marker.bindPopup(content, {
          className: 'stockists__popup',
          maxWidth: 280,
          minWidth: 220,
          autoPanPadding: [24, 24]
        });
      }

      // クリック・Enter どちらで開いても一覧側の強調を合わせる
      marker.on('popupopen', function () {
        self.select(i);
      });

      marker.addTo(self.map);
      self.markers[i] = marker;
    });

    /*
     * サイズ合わせ。hidden を解いた直後や、テーマエディタがセクションを差し込んだ直後は
     * まだ寸法が確定していない。先に測り直してから範囲を合わせ、レイアウトが落ち着いた
     * ところでもう一度やる（順番を逆にすると、狂った寸法のまま変な位置へズームする）。
     */
    var settle = function () {
      self.map.invalidateSize();
      self.fitAll();
      self.syncPrefLabels();
    };

    settle();
    if (window.requestAnimationFrame) window.requestAnimationFrame(settle);
    setTimeout(settle, 300);

    // 以後の幅の変化（画面回転・テーマエディタの再描画）にも追従する
    if (window.ResizeObserver) {
      new window.ResizeObserver(function () {
        self.map.invalidateSize();
        self.syncPrefLabels();
      }).observe(this.mapEl);
    }
  };

  /* ---------- 起動 ---------- */

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-stockists]'), function (root) {
      if (root.__stockists) return;
      root.__stockists = new Stockists(root);
      instances.push(root.__stockists);
      root.__stockists.initMap();
    });
  }

  window.JpnStockists = { boot: boot };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // テーマエディタでセクションを差し替えた時にも初期化する
  document.addEventListener('shopify:section:load', boot);
})();
